import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import { useMessagesStore } from '@/stores/messages'

export const useStoryLocationsStore = defineStore('storyLocations', {
  state: () => ({
    storyLocations: [],
    fetchInitiated: false
  }),

  getters: {
    locationIds({ storyLocations }) {
      return storyLocations.map(({ location: { id } }) => id)
    }
  },

  actions: {
    async fetch({ storyId }) {
      this.fetchInitiated = true

      return httpClient.get(`/api/internal/stories/${storyId}/story_locations`)
        .then(response => {
          this.storyLocations = response.data.story_locations
        })
        .catch((err) => {
          useMessagesStore().smartAdd(err)
        })
    },

    async fetchOnce() {
      if (this.fetchInitiated) return Promise.resolve()

      return this.fetch()
    },

    async create({ storyId, locationId }) {
      return httpClient.post(`/api/internal/stories/${storyId}/story_locations`, { location_id: locationId })
        .then(response => {
          this.storyLocations.push(response.data.story_location)
        })
        .catch((err) => {
          useMessagesStore().smartAdd(err)
        })
    },

    async destroy({ storyId, storyLocationId }) {
      return httpClient.delete(`/api/internal/stories/${storyId}/story_locations/${storyLocationId}`)
        .then(() => {
          this.storyLocations = this.storyLocations.filter((storyLocation) => storyLocation.id !== storyLocationId)
        })
        .catch((err) => {
          useMessagesStore().smartAdd(err)
        })
    }
  }
})
